

export const TAB_TITLE_MAPPING = {
  "about us": "About us",
  "accreditations awards": "Our Accreditations",
  "address": "Addresses",
  "apprenticeship": "Apprenticeships",
  "courses": "Our Courses",
  "work experience": "Experiences of work"
};


export const COMPLETED_SUB_TAB_TITLE = {
    "ABOUT_US": "Our Purpose",
    "OUR_TEAM": "Our Team",
    "OUR_CLIENT": "Our Client",
    "OUR_STORY": "Our Story",
    "OUR_SUPPORTERS": "Our Supporters",
    "ACCREDITATIONS_AWARDS": "Our Accreditations",
    "SALES": "Sales",
    "CAREERS": "Careers",
    "CONTRACTS": "Contracts",
    "EXPERIENCES_OF_WORK": "Experiences of work",
    "VOLUNTEERING": "Volunteering",
    "ADDRESS": "Addresses",
    "GETTING_TO_US": "Getting to us",
    "REVIEWS": "Reviews",
    "CUSTOMER_SERVICES": "Customer services",
    "SOCIAL_MEDIA": "Social media",
    "PERSONAL_INFO": "Personal Info",
    "HUMAN_RESOURCE": "Careers",
};


export const getTabDisplayName = (title) => {
  return TAB_TITLE_MAPPING[title?.trim()?.toLowerCase()] || title;
};

export const getSubTabDisplayName = (title) => {
  return COMPLETED_SUB_TAB_TITLE[title] || title;
};


export const EXISTING_MEMBER_QUESTIONS = {
  "exhibition company": "Are you an Existing Exhibitor?",
  "b2b publisher": "Are you an Existing Advertiser?",
  "growth hub": "Are you an Existing Client?",
  "innovation centre": "Are you an Existing Member?",
  "trade body": "Are you an Existing Member?",
  "chamber of commerce": "Are you an Existing Member?",
};